import React, { createContext, useState } from "react";
import { LOGIN_URL } from "../services/endpoints";
import { axiosInstancePublic } from "../services/axios-instance";

interface ContextData {
    session: null | string;
    setSession: React.Dispatch<React.SetStateAction<null | string>>;
    login: (email: string, password: string) => void;
}

export const AuthContext = createContext({} as ContextData);

interface Props {
    children: React.ReactNode;
}

export const AuthProvider: React.FC<Props> = ({ children }) => {
    const [session, setSession] = useState<null | string>(null);

    async function login(email: string, password: string) {
        try {
            const response = await axiosInstancePublic.post(LOGIN_URL, {
                email,
                password,
            });
            const token = response.data;
            localStorage.setItem("token", token.access_token as string);
            setSession(token.access_token);
        } catch (error: any) {
            throw error;
        }
    }
    const contextObj: ContextData = {
        session,
        setSession,
        login,
    };
    return (
        <AuthContext.Provider value={contextObj}>
            {children}
        </AuthContext.Provider>
    );
};
